import React from 'react';
import { LOCKER_SIZES } from './LockerSizeSelector';

const BookingSummary = ({ 
  selectedDate, 
  selectedTime, 
  hours, 
  selectedSize, 
  quantity,
  showFull = false 
}) => {
  const selectedLocker = LOCKER_SIZES.find(l => l.id === selectedSize);
  const totalPrice = selectedLocker ? selectedLocker.price * hours * quantity : 0;
  const endHour = selectedTime 
    ? String(parseInt(selectedTime.split(':')[0]) + hours).padStart(2, '0') 
    : '00';

  return (
    <div className="bg-[#0A0A0A] border border-[#2A2A2A] p-4 mt-6">
      <h4 className="text-white font-semibold mb-2">
        {showFull ? 'Riepilogo Finale' : 'Riepilogo'}
      </h4>
      <div className="space-y-1 text-sm">
        {showFull && (
          <p className="text-gray-400">
            Locker: <span className="text-white">{quantity}x {selectedLocker?.name} ({selectedLocker?.label})</span>
          </p>
        )}
        <p className="text-gray-400">
          Data: <span className="text-white">
            {selectedDate?.toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long' })}
          </span>
        </p>
        <p className="text-gray-400">
          Orario: <span className="text-white">
            {selectedTime} - {endHour}:00{showFull ? ` (${hours}h)` : ''}
          </span>
        </p>
        {!showFull && (
          <>
            <p className="text-gray-400">
              Durata: <span className="text-white">{hours} {hours === 1 ? 'ora' : 'ore'}</span>
            </p>
            <p className="text-gray-400">
              Quantità: <span className="text-white">{quantity} locker</span>
            </p>
          </>
        )}
      </div>
      <div className="border-t border-[#2A2A2A] mt-3 pt-3">
        <div className="flex justify-between items-center text-sm text-gray-400 mb-1">
          <span>€{selectedLocker?.price.toFixed(2).replace('.', ',')} × {hours}h × {quantity}{showFull ? ' locker' : ''}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-gray-400">{showFull ? 'Totale da pagare:' : 'Totale:'}</span>
          <span className="text-[#FFCC00] text-2xl font-bold">€{totalPrice.toFixed(2).replace('.', ',')}</span>
        </div>
      </div>
    </div>
  );
};

export default BookingSummary;
